// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ecasenkaDetail hr[data-v-12ddd39a]{margin:.5rem}", ""]);
// Exports
module.exports = exports;
